export default "__VITE_ASSET__BtrWA4dX__"